<template>
    <div class="position-box">
        <div class="head">
            <img class="back" src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('langNew.zhye')}}</div>
        </div>
        <div class="cotainer">
            <div class="assets-wrap">
                <img class="user-bg" src="@/assets/new/user-bg.png" alt="">
                <div class="assets-box">
                    <div class="assets-lt">
                        <div class="assets-tips">
                            <div class="text">{{$t('assets.total')}}(USDC)</div>
                        </div>
                        <div class="assets" v-show="money">{{money | balance}}</div>
                    </div>
                </div>
            </div>
            <ul class="checkbox-box">
                <input id="checkbox" v-model="check" class="checkbox" type="checkbox">
                <div class="text"><label for="checkbox">{{$t('assets.yczc')}}</label></div>
            </ul>
            <ul class="currency-box">
                <li class="currency-li" v-for="(item,index) in list" :key="index">
                    <div class="currency">
                        <div class="money">{{item.currency | rewriteName}}</div>
                    </div>
                    <div class="currency-item">
                        <div class="item-lt">
                            <div class="t1">{{$t('assets.avaiable')}}</div>
                            <div class="t2">{{item.positions | balance}}</div>
                        </div>
                        <div class="item-rt">
                            <div class="t1">{{$t('assets.conversion')}}(USDC)</div>
                            <div class="t2">{{ item.zh | balance }}</div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: 'myAssets',
    data () {
        return {
          theme: false,
          money: '',
          list:[],
          currencyAll: [],
          check: false
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
    },
    mounted() {
      this.getCurrencyAll();
    },
    methods: {
       back(){
           this.$router.push('/index')
       },
       getCurrencyAll(){//所有币种
          this.$ajax.post('/web/getCurrencyAll').then((res) => {
            let resData = res.data.data;
            if(res.data.code == 0){
              this.currencyAll = resData;
              this.getAsset()
            }
          }).catch(function(err){
              console.log(err)
          })
        },
       getAsset(){
           this.$ajax.get('/web/getAsset2',{}).then((res) => {
                let resData = res.data.data;
                this.money = resData.totalMoney;
                if(this.check){
                    this.list = resData.list.filter((item) =>{
                        return item.positions > 0;
                    })
                    this.list = this.list.map(item => {
                      this.currencyAll.forEach(item2 => {
                        if(item.currency == item2.name.toUpperCase()){
                          var obj = {icon: item2.icon}
                          item = { ...item,...obj};
                        }
                      })
                      return item
                    })
                }else{
                    this.list = resData.list.map(item => {
                      this.currencyAll.forEach(item2 => {
                        if(item.currency == item2.name.toUpperCase()){
                          var obj = {icon: item2.icon}
                          item = { ...item,...obj};
                        }
                      })
                      return item
                    })
                }
            }).catch(function(err){
                console.log(err)
            })
       },
    },
    beforeDestroy(){

    },
    watch: {
      check:function(){
        this.getAsset();
      }
	},
}
</script>
<style scoped>
.position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .52rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.2rem;
        padding: 0 .44rem;
        color: #fff;
        line-height: 1.2rem;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .32rem;
        margin-top: -.3rem;
    }
    .head .title{
        font-size: .52rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
        position: absolute;
        left: .32rem;
        right: .32rem;
        top: 1.2rem;
        bottom: 0;
        overflow-y: scroll;
    }
    .assets-wrap{
        position: relative;
        height: 2.68rem;
        margin: 0 0 .24rem;
    }
    .assets-wrap .user-bg{
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 2.68rem;
    }
    .assets-wrap .assets-box{
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        width: 100%;
        height: 2.68rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .6rem .4rem .7rem;
        box-sizing: border-box;
    }
    .assets-wrap .assets-box .assets-tips{
        display: flex;
        align-items: center;
    }
    .assets-wrap .assets-box .assets-tips .text{
        padding-right: .3rem;
        color: #fff;
        font-size: .4rem;
    }
    .assets-wrap .assets-box .assets-tips .icon{
        width: .6rem;
    }
    .assets-wrap .assets-box .assets{
        padding-top: .3rem;
        color: #fff;
        font-size: .6rem;
    }
    .assets-wrap .assets-box .button{
      padding: .3rem .3rem;
      font-size: .36rem;
      white-space: nowrap;
      border: 1px solid #fff;
      border-radius: .5rem;
    }
    .assets-wrap .assets-box .arrow{
        width: .2rem;
    }
    .checkbox-box{
        display: flex;
        align-items: center;
    }
    .checkbox-box .text{
        padding-left: .2rem;
        color: #666;
        font-size: .42rem;
    }
    .currency-li{
      display: flex;
      align-items: center;
      margin: .24rem 0;
      padding: .3rem;
      background: rgba(41, 55, 68, .2);
      border-radius: 4px;
    }
    .currency-li .currency{
      display: flex;
      align-items: center;
        color: #7f7f7f;
        font-size: .42rem;
    }
    .currency-li .currency .icon{
      width: 1rem;
      margin-right: .3rem;
    }
    .currency-li .currency-item{
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex: 1;
        margin-left: .6rem;
    }
    .currency-li .currency-item .item-rt{
      text-align: right;
    }
    .currency-li .currency-item .t1{
        padding-top: .24rem;
        color: #7f7f7f;
        font-size: .36rem;
    }
    .currency-li .currency-item .t2{
        padding-top: .24rem;
        color: #7f7f7f;
        font-size: .42rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/myAssets.vue